const WEBSITES = {
  PAGE_TITLE: 'داشبورد | رایچت',

  HEADING_TITLE: 'لیست وب‌سایت ها',
  WELCOME: 'خوش آمدید',
  HEADING_SUBTITLE:
    'شما می‌توانید در اینجا ضمن مشاهده لیست سایت‌ها، تکه کد منحصر به فرد هر سایت را دریافت کنید، ابزارک رایچت را فعال یا غیرفعال کنید، اپراتورها را تخصیص دهید و به آرشیو مکالمات دسترسی داشته باشید.',
  HONOR_TEXT:
    'امیدواریم بتوانیم افتخار خدمت رسانی برای شما کاربر عزیز را داشته باشیم',
  DASHBOARD_HELP: 'راهنمای داشبورد',
  ADD_WEBSITE: 'افزودن وب سایت',
  SEE_ALL_WEBSITES: 'نمایش همه وب سایت ها',

  CUSTOMIZATION: 'شخصی سازی',
  DELETE_WEBSITE: 'حذف وب سایت',
  CHOOSE_WEBSITE: 'انتخاب وب سایت',
  // CHOSEN_WEBSITE: '',

  DASHBOARD_NAME: 'داشبورد',
  PACKAGE_TYPE: 'نوع پکیج شما',
  REMAINING_CHARGE: 'شارژ باقی مانده',
  REMAINING_SERVICE: 'سرویس باقی مانده',
  REVIVE_SERVICE: 'تمدید سرویس',
  SERVICE_END: 'اتمام سرویس',
  EXPIRE_SOON:
    'سرویس شما #days# روز دیگر به پایان میرسد لطفا جهت استفاده از امکانات رایچت تمدید کنید با تشکر!',
  SERVICE_END_DESC:
    'سرویس شما به اتمام رسیده لطفا جهت استفاده از امکانات رایچت تمدید کنید با تشکر!',
  DAY: 'روز',
  MESSAGE: 'پیام',

  WEBSITE_WORD: 'وب سایت',
  GENERAL_STATISTICES: 'آمار کلی',
  WORKSPACES_N: 'تعداد وب سایت ها ',
  COMING: 'به زودی...',
  USERS_N: 'تعداد کل کاربران',
  CONVERSATIONS_N: 'تعداد همه مکالمات',
  OPERATORS_N: 'تعداد اپراتور ها',

  ALL_CONVS: 'تعداد مکالمات',
  ALL_USERS: 'تعداد کاربران',
  CONVERSION_RATE: 'نرخ تبدیل به مکالمه',

  ACTIVE: 'فعال',
  INACTIVE: 'غیرفعال',

  // WebsiteListMain

  // WebsiteItemHeader
  SETTINGS: 'نصب و تنظیمات',
  ASSIGN_OPERATOR: 'تخصیص اپراتور',
  ARCHIVES: 'آرشیو مکالمات',

  // WebsiteItemOperators
  OPERATORS: 'اپراتورها',
  THERE_IS_NO_OPERATOR: 'اپراتوری به این وب سایت تخصیص داده نشده است.',

  // WebsiteItemWidget
  INSTALL_SCRIPT_NOT_FOUND: 'کد ابزارک در این سایت نصب نشده است',
  INSTALL_INSTRUCTION: 'لطفا تکه کد را قبل از اتمام تگ #head# جایگذاری کنید',
  GET_SCRIPT: 'دریافت تکه کد',
  THERE_IS_NO_DATA: 'در حال حاضر آماری ثبت نشده است.',

  // AcceptedConversationsChart
  ACCEPTED_CONVERSATIONS: 'مكالمات قبول شده',
  CLOSED_CONVERSATIONS: 'مكالمات بسته شده',
  CLOSED_AGENT_CONVERSATION: 'مکالمات بدون پاسخ',
  DENIED_CONVERSATION: 'مکالمات رد شده',

  TODAY: 'امروز',

  MODAL: {
    // InstallWidgetModal
    INSTALL_WIDGET_TITLE: 'نصب تکه کد در وب‌سایت',
    INSTALL_WIDGET_SUBTITLE_TITLE:
      'برای فعال‌سازی رایچت تکه کد زیر را قبل از اتمام تگ #head# جایگذاری کنید',
    INSTALL_WIDGET_COPY_CODE: 'كپی تكه كد',

    // AddWebsiteModal
    ADD_WEBSITE_TITLE: 'افزودن وب سایت جدید',
    ADD_WEBSITE_FORM_TITLE: 'عنوان وب سایت',
    ADD_WEBSITE_FORM_ADDRESS: 'example.com :آدرس وب‌سایت',
    ADD_WEBSITE_FORM_ADD_ALL: 'افزودن تمام اپراتورها به این وب سایت',

    ADD_WEBSITE_FOOTER_CONFIRM: 'افزودن وب سایت',

    // AssignOperatorsModal

    ASSIGN_OPERATOR_TITLE: 'تخصیص/ عدم تخصیص اپراتور',
    ASSIGN_OPERATOR_SEARCH: 'جست و جوی اپراتور',
    ASSIGN_OPERATOR_OPERATORS: 'اپراتورها',
    ASSIGN_OPERATOR_OPERATOR: 'اپراتور',
    ASSIGN_OPERATOR_HINT:
      'برای تخصیص اپراتور به سایت یا عدم تخصیص آن بر روی آواتار کلیک کنید.',

    CLOSE: 'بستن',
    CANCEL: 'انصراف',
    SAVE: 'ذخیره',
  },
  DELETE_TITLE: 'حذف وب‌سایت',
  DELETE_DESC: 'آیا از حذف و‌ب‌سایت اطمینان دارید؟',
  DELETE_CONFIRMATION_BTN: 'تایید',
  DELETE_CANCEL_BTN: 'خیر',
  DISABLE_DELETE_TOOLTIP: 'برای حذف وب‌سایت نیاز به ارتقاء پکیج دارید: ',
  BUY_PACKAGE: 'خرید',
};

export default WEBSITES;
